export default {
  en: {
    unifiedDashboardPage: {
      allElections: "All Elections",
      presidential: "Presidential",
      parliamentary: "Parliamentary",
      senatorial: "Senatorial",
      council: "Council",
      regional: "Regional",
      unknown: "Unknown",
      loading: "Loading election results...",
      title: "Cameroon Election Results",
      subtitle: "Live results from all election types • Last updated: {{time}}",
      selectElectionType: "Select Election Type",
      live: "Live",
      paused: "Paused",
      totalVotesCast: "Total Votes Cast",
      resultsReported: "Results Reported",
      approved: "Approved",
      certified: "Certified",
      viewDetails: "View Details",
      leading: "Leading",
      votesCount: "{{n}} votes",
      totalVotes: "Total Votes",
      noData: "No data available",
      shareLive: "Share live results",
      shareTitleAll: "Cameroon Election Results",
      shareTitleType: "Cameroon {{type}} Results",
      shareText: "View live election results from Cameroon",
      noDataFor: "No data available for {{type}}",
      validVotes: "Valid Votes",
      rejectedVotes: "Rejected Votes",
      notAvailable: "N/A",
      currentLeader: "Current Leader",
      resultsDistribution: "Results Distribution",
      votes: "Votes",
      voteShare: "Vote Share",
      detailedResults: "Detailed Results",
      candidate: "Candidate",
      party: "Party",
      progress: "Progress"
    }
  },
  fr: {
    unifiedDashboardPage: {
      allElections: "Toutes les élections",
      presidential: "Présidentielle",
      parliamentary: "Législatives",
      senatorial: "Sénatoriales",
      council: "Municipales",
      regional: "Régionales",
      unknown: "Inconnu",
      loading: "Chargement des résultats électoraux...",
      title: "Résultats des élections au Cameroun",
      subtitle: "Résultats en direct de tous les types d'élections • Dernière mise à jour : {{time}}",
      selectElectionType: "Sélectionner le type d'élection",
      live: "En direct",
      paused: "En pause",
      totalVotesCast: "Total des votes exprimés",
      resultsReported: "Résultats rapportés",
      approved: "Approuvés",
      certified: "Certifiés",
      viewDetails: "Voir les détails",
      leading: "En tête",
      votesCount: "{{n}} votes",
      totalVotes: "Total des votes",
      noData: "Aucune donnée disponible",
      shareLive: "Partager les résultats en direct",
      shareTitleAll: "Résultats des élections au Cameroun",
      shareTitleType: "Résultats {{type}} – Cameroun",
      shareText: "Consultez les résultats électoraux en direct du Cameroun",
      noDataFor: "Aucune donnée disponible pour {{type}}",
      validVotes: "Votes valides",
      rejectedVotes: "Votes rejetés",
      notAvailable: "N/D",
      currentLeader: "Candidat en tête",
      resultsDistribution: "Répartition des résultats",
      votes: "Votes",
      voteShare: "Part des votes",
      detailedResults: "Résultats détaillés",
      candidate: "Candidat",
      party: "Parti",
      progress: "Progression"
    }
  }
};
